<template>
  <md-menu md-direction="bottom-start" @md-closed="$emit('menuClosed')" :md-active="showMenu">
    <!--<md-button md-menu-trigger>Bottom Start</md-button>-->

    <md-menu-content>
      <md-menu-item disabled v-if="showMenuTitle">
        <slot name="menu-title">{{ menuTitle }}</slot>
      </md-menu-item>
      <md-menu-item
        v-if="$can('view', 'WorkPlan', 'securityphotos')"
        @click="menuSelected('securityPhotos')"
      >
        <md-icon>photo</md-icon>
        <div class="md-list-item-text">Fotos de seguridad</div>
      </md-menu-item>
      <md-menu-item
        v-if="$can('view', 'Commons', 'conceptfiles')"
        @click="menuSelected('evidences')"
      >
        <md-icon>photo</md-icon>
        <div class="md-list-item-text">Evidencias</div>
      </md-menu-item>

      <md-menu-item
        v-if="
          $can('view', 'Commons', 'conceptfiles') &&
          !isExtranet &&
          affected.requiredGO &&
          affected.requiredBTC
        "
        @click="menuSelected('generators')"
      >
        <md-icon>assignment_turned_in</md-icon>
        <div class="md-list-item-text">Generadores de obra y bitácoras</div>
      </md-menu-item>

      <!--
      <md-menu-item
        v-if="$can('view', 'WorkPlan', 'assistance')"
        @click="menuSelected('assistance')"
      >
        <md-icon>person</md-icon>
        <div class="md-list-item-text">Asistencia de trabajadores</div>
      </md-menu-item>
      -->

      <md-menu-item v-if="showSetRealQuantities || true" @click="menuSelected('setRealQuantities')">
        <md-icon>widgets</md-icon>
        <div class="md-list-item-text">Ejecución de Conceptos</div>
      </md-menu-item>
      <md-menu-item v-if="$can('view', 'Sinister', 'binnacle')" @click="menuSelected('binnacle')">
        <md-icon>list</md-icon>
        <div class="md-list-item-text">Bitácora de Siniestro</div>
      </md-menu-item>
      <md-menu-item
        v-if="$can('view', 'Sinister', 'extranetbinnacle')"
        @click="menuSelected('extranetBinnacle')"
      >
        <md-icon>list</md-icon>
        <div class="md-list-item-text">Bitácora Ext</div>
      </md-menu-item>
      <md-menu-item
        @click="menuSelected('reject')"
        v-if="
          canDeleteWorkplanreal && $can('delete', 'WorkPlan', 'workplanreal')
        "
      >
        <md-icon>backspace</md-icon>
        <div class="md-list-item-text">Rechazar</div>
      </md-menu-item>
      <md-menu-item
        @click="!executionEndDisabled && menuSelected('end')"
        v-if="
          showExecutionEnd &&
          hasRequiredPhotos &&
          $can('add', 'WorkPlan', 'workplanreal')
        "
        :disabled="executionEndDisabled"
      >
        <md-icon>check</md-icon>
        <div class="md-list-item-text">Finalizar</div>
      </md-menu-item>
      <md-menu-item @click="menuSelected('reviewed')" v-if="showCloseAuthorization">
        <md-icon>done_all</md-icon>
        <div class="md-list-item-text">Revisar</div>
      </md-menu-item>
      <!--
    <md-menu-item @click="menuSelected('registerMaterialOutput')">
      Registrar salida de material
    </md-menu-item>
    <md-menu-item @click="menuSelected('modify')">
      Modificar
    </md-menu-item>
      -->
    </md-menu-content>
  </md-menu>
</template>

<script>
import usesAccountInfoMixin from "@/mixins/usesAccountInfo";
import catalogService from "@/services/catalog";
import purchaseService from "@/services/purchase";
import { PHOTO_TYPES } from "./utils";
import { mapPermissions } from "@/plugins/accountPermissions/";

const filesGroupedByFiletype = (files) => {
  const obj = {};
  for (const file of files) {
    const id = file.fileTypeId;
    let arr = obj[id];

    if (!arr) {
      arr = [];
      obj[id] = arr;
    }
    arr.push(file);
  }

  return obj;
};
const MENU_TIMEOUT = 50;
export default {
  mixins: [usesAccountInfoMixin],

  name: "TaskMenu",

  props: {
    currentTask: {
      type: Object,
      default: true,
    },
    showExecutionEnd: {
      type: Boolean,
      default: false,
    },
    executionEndDisabled: {
      type: Boolean,
      default: false,
    },
    disabledFields: {
      type: Array,
      default: () => [],
    },
    hiddenFields: {
      type: Array,
      default: () => [],
    },
    showCloseAuthorization: {
      type: Boolean,
      default: false,
    },
    menuTitle: {
      type: String,
      required: false,
    },
    showMenuTitle: {
      type: Boolean,
      required: false,
    },
    showSetRealQuantities: {
      type: Boolean,
      required: false,
    },
    isExtranet: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    ...mapPermissions("WorkPlan", "workplanreal"),
    affected() {
      const { planExpected } = this.currentTask;
      return planExpected ? planExpected.affected : {};
    },
    photoTypesManager() {
      const { requiredGO, requiredBTC } = this.affected;
      const requiredFiles = requiredGO && requiredBTC;
      const optional = [
        {
          fileCode: "GOF",
          required: requiredFiles,
          missingFileLabel: "#GeneradorFinal",
        },
        {
          fileCode: "GOD",
          required: requiredFiles,
          missingFileLabel: "#GeneradorDiario",
        },
        {
          fileCode: "BTCF",
          required: requiredFiles,
          missingFileLabel: "#BitacoraFinal",
          noConceptGrouping: true,
        },
        {
          fileCode: "BTC",
          required: requiredFiles,
          missingFileLabel: "#Bitácora",
          noConceptGrouping: true,
        },
      ];
      return [...PHOTO_TYPES, ...optional].filter((type) =>
        this.isExtranet
          ? !["ALMSAL", "RETSAL", "panoramic"].includes(type.fileCode)
          : !!type
      );
    },

    conceptsById() {
      const obj = {};

      for (const concept of this.concepts) {
        obj[concept.id] = concept;
      }

      return obj;
    },
    hasRequiredPhotos() {
      const { fileTypes, photoTypesManager, nonConceptPhotos } = this;
      if (!fileTypes) {
        return false;
      }
      const missingRequired = photoTypesManager.filter(
        ({ required, noConceptGrouping, fileCode }) =>
          required
            ? !noConceptGrouping
              ? !fileTypes[fileCode].hasAllConcepts
              : !nonConceptPhotos.some((f) => f.codename === fileCode)
            : false
      );
      return missingRequired.length === 0;
    },
  },

  methods: {
    menuSelected(itemSelected) {
      this.$emit("menuSelected", itemSelected);
      this.$emit("menuClosed");
    },
    verifyPhotos() {
      const keys = Object.keys(this.fileTypes);
      keys.forEach((type) => {
        let photos = {};
        let photosByConcept = {};
        if (!type.noConceptGrouping) {
          photos = filesGroupedByFiletype(this.conceptPhotos);
        } else {
          photos = filesGroupedByFiletype(
            this.nonConceptPhotos.map((f) => ({
              ...f,
              fileTypeId: f.fileTypeId,
            }))
          );
        }

        photosByConcept = photos[this.fileTypes[type].id]
          ? this.photosByConcept(photos[this.fileTypes[type].id])
          : {};
        const missingConcepts = this.concepts
          .filter((concept) => !photosByConcept[concept.name])
          .map((concept) => concept.name);

        this.fileTypes[type].hasAllConcepts = missingConcepts.length === 0;
      });
    },
    photosByConcept(photos) {
      const obj = {};
      for (const photo of photos) {
        const concept = this.conceptsById[photo.conceptId];
        const cName = concept ? concept.name : "";

        const conceptName = `${cName}`;

        const stuff = obj[conceptName];
        const photoObj = {
          src: photo.file,
          thumb: photo.smallPhoto,
          original: photo,
          label: photo.label,
          conceptName,
        };
        if (!stuff) {
          obj[conceptName] = [photoObj];
        } else {
          stuff.push(photoObj);
        }
      }

      return obj;
    },
  },

  data() {
    return {
      showMenu: false,
      loadingPhotos: true,
      nonConceptPhotos: [],
      conceptPhotos: [],
      concepts: [],

      fileTypes: null,
    };
  },
  mounted() {
    const { photoTypesManager, isExtranet } = this;
    catalogService.fetch("common/filetype").then((fileTypes) => {
      const fTypes = {};
      photoTypesManager.map(({ fileCode }) => {
        let fileType = fileTypes.find((f) => f.codename == fileCode);

        if (!fileType) {
          fileType = {
            id: fileCode, // used for keying
            codename: displayInfo.missingFileLabel || fileCode,
            name: fileCode,
          };
        }

        fTypes[fileCode] = {
          ...fileType,
          file: null,
          hasAllConcepts: false,
        };
      });

      this.fileTypes = fTypes;
    });

    const filesUrl = isExtranet ? "customer_conceptfiles" : "conceptfiles";
    const filesUrlExtranet = isExtranet ? "get_customer_files" : "getfile";
    const NON_CONCEPTS_PHOTO_TYPES = photoTypesManager
      .filter(({ noConceptGrouping }) => !!noConceptGrouping)
      .map(({ fileCode }) => fileCode);

    Promise.all([
      catalogService.fetch(`common/${filesUrl}/byAffected`, {
        id: this.affected.id,
        collection: true,
      }),
      catalogService.fetch(`common/file/${filesUrlExtranet}`, {
        id: this.affected.id,
        collection: true,
      }),
      purchaseService.fetchQuantification(this.affected.id),
    ])
      .then((res) => {
        this.conceptPhotos = [
          ...res[0].map((p) => ({
            ...p,
            label: p.addDate,
          })),
        ];
        this.nonConceptPhotos = res[1].filter(({ codename: type }) =>
          NON_CONCEPTS_PHOTO_TYPES.includes(type)
        );

        if (!res[2]) {
          return;
        }
        this.concepts = res[2].concepts.filter((c) => !c.notToDo);

        this.verifyPhotos();
      })
      .finally(() => {
        this.showMenu = true;
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/TaskMenu.vue